import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ContentListhooks } from '../../Helper/ContentHelper';
import { hasCreatePermission, hasdeletePermission, hasEditPermission, hasSharePermission } from "../../Utils/PermissionUtils";
import ShareModal from '../../Utils/ShareModal';
import { toast } from 'react-toastify';
import service from '../../Services/service';
import DeleteModal from '../../Utils/DeleteModal';
import { FILE_BASE_URL } from '../../Config/constants';

function ContentListComponent() {
    // State to hold the content data, filters, and pagination
    const [contentData, setContent] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('Name');
    const [sortDescending, setSortDescending] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalitems, setTotalitems] = useState(0);

    const [showModal, setShowModal] = useState(false);
    const [selectedScreenName, setSelectedScreenName] = useState('');
    const [selectedrowId, setSelectedRowId] = useState(0);

    const canEditContent = hasEditPermission('Content');
    const canDeleteContent = hasdeletePermission('Content');
    const canShareContent = hasSharePermission('Content');

    const [deleteId, setDeleteId] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    // Fetch data when the component mounts or any dependencies change
    useEffect(() => {
        getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
    }, [searchTerm, sortBy, sortDescending, pageNumber, pageSize]);

    async function getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize) {

        const data = await ContentListhooks(searchTerm, sortBy, sortDescending, pageNumber, pageSize);

        if (data) {
            setContent(data.items);
            setTotalPages(data.totalPages);
            setTotalitems(data.totalItems)
        }
    }



    // Handle the change of sorting options
    const handleSortChange = (event) => {
        const [field, order] = event.target.value.split('_');
        setSortBy(field);
        setSortDescending(order === 'desc');
    };

    // Handle page change
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPageNumber(newPage);
        }
    };

    const handleDeleteClick = (id, name) => {
        setSelectedScreenName(name)
        setDeleteId(id);
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = async () => {
        try {
            const response = await service.getdata("Content/DeleteById?id=" + deleteId);
            if (response !== undefined) {
                toast.success('Content Deleted successfully!');
                // Replace below with your actual refresh logic
                getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
            }
        } catch (error) {
            toast.error('Error deleting Content. Please try again.');
        } finally {
            setShowDeleteModal(false);
        }
    };

    return (
        <div>
            <div class="container-fluid content-top-gap">
                <nav aria-label="breadcrumb" class="mb-4">
                    <ol class="breadcrumb my-breadcrumb">
                        <li class="breadcrumb-item"><a href="/">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Content List</li>
                    </ol>
                </nav>

                <div class="accordions">
                    <div class="row">

                        <div class="col-lg-12 mb-4">
                            <div class="card card_border mb-4">
                                <div className="card-header chart-grid__header d-flex justify-content-between align-items-center">
                                    <h5 className="mb-0">Content Management</h5>
                                    {hasCreatePermission('Content') && (
                                        <Link to="/CreateContent" className="btn btn-outline-primary btn-sm">
                                            Add Content
                                        </Link>
                                    )}
                                </div>

                                <div class="card-body">

                                    <div className='row mb-3'>
                                        <div className='col-md-4 '>
                                            <input type="text" className='form-control' placeholder="Search by name..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                                        </div>
                                        <div className="col-md-4 mt-2 mt-md-0">
                                            <select
                                                className="custom-select"
                                                onChange={handleSortChange}
                                                value={`${sortBy}_${sortDescending ? 'desc' : 'asc'}`}
                                            >
                                                <option value="Name_asc">Name (A-Z)</option>
                                                <option value="Name_desc">Name (Z-A)</option>
                                                <option value="CreatedAt_asc">Created At (Oldest)</option>
                                                <option value="CreatedAt_desc">Created At (Newest)</option>
                                                <option value="UpdatedAt_asc">Updated At (Oldest)</option>
                                                <option value="UpdatedAt_desc">Updated At (Newest)</option>
                                                <option value="CreatedBy_asc">Created By (A-Z)</option>
                                                <option value="CreatedBy_desc">Created By (Z-A)</option>
                                            </select>
                                        </div>
                                        <div className="col-md-4 mt-2 mt-md-0">
                                            <select
                                                className="custom-select"
                                                value={pageSize}
                                                onChange={(e) => {
                                                    setPageSize(Number(e.target.value));
                                                    setPageNumber(1); // reset to page 1
                                                }}
                                            >
                                                <option value={10}>Show 10</option>
                                                <option value={20}>Show 20</option>
                                                <option value={50}>Show 50</option>
                                                <option value={100}>Show 100</option>
                                            </select>
                                        </div>
                                    </div>
                                    <table className="table table-striped table-bordered table-hover" style={{ fontSize: '14px' }}>
                                        <thead className="bg-light">
                                            <tr>
                                                <th>Content ID</th>
                                                <th>Media</th>
                                                <th>Type</th>
                                                <th>Name</th>
                                                <th>Created By</th>
                                                <th>Created On</th>
                                                <th style={{ width: '220px' }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {contentData.map((content, index) => (
                                                <tr key={content.contentId}>
                                                    <td>{index + 1}</td>
                                                    <td style={{ width: '150px' }}>
                                                        {content.type === 'Video' ? (
                                                             <a
                                                                href={`${FILE_BASE_URL}/${encodeURIComponent(content.url)}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="btn btn-outline-secondary btn-sm"
                                                            >
                                                                📄 View Video
                                                            </a>
                                                        ) : content.type === 'Image' ? (
                                                            <img
                                                                src={`${FILE_BASE_URL}/${encodeURIComponent(content.url)}`}
                                                                alt={content.title}
                                                                width="100"
                                                                className="img-thumbnail"
                                                            />
                                                        ) : content.type === 'PDF' ? (
                                                            <a
                                                                href={`${FILE_BASE_URL}/${encodeURIComponent(content.url)}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="btn btn-outline-secondary btn-sm"
                                                            >
                                                                📄 View PDF
                                                            </a>
                                                        ) : (
                                                            <span className="text-muted">N/A</span>
                                                        )}
                                                    </td>
                                                    <td>{content.type}</td>
                                                    <td>{content.title}</td>
                                                    <td>{content.createdUserName}</td>
                                                    <td>{content.createdAt}</td>
                                                    <td>
                                                        <div className="btn-group" role="group">
                                                            {/* {canEditContent && (
                                                                <>
                                                                    <Link to={`/EditLayout/${content.contentId}`} className="btn btn-outline-info btn-sm" title="Edit Layout">
                                                                        Edit
                                                                    </Link>

                                                                </>
                                                            )} */}

                                                            {canDeleteContent && (
                                                                <Link to="#" className="btn btn-outline-danger btn-sm" title="Delete Content" onClick={() => handleDeleteClick(content.contentId, content.title)}>
                                                                    Delete
                                                                </Link>
                                                            )}
                                                            {
                                                                canShareContent && (
                                                                    <Link
                                                                        className="btn btn-outline-success btn-sm"
                                                                        title="Share"
                                                                        onClick={() => {
                                                                            setSelectedScreenName(content.title);
                                                                            setShowModal(true);
                                                                            setSelectedRowId(content.contentId);
                                                                        }}
                                                                    >
                                                                        Share
                                                                    </Link>
                                                                )
                                                            }
                                                        </div>
                                                    </td>
                                                    {/* <td>
                                            <button className="btn btn-warning"> <i className="fa fa-trash fa-lg" aria-hidden="true"></i></button>&nbsp;
                                            <Link to={'/EditContent/' + content.contentId} className="btn btn-danger"> <i className="fa fa-edit fa-lg" aria-hidden="true"></i></Link>  &nbsp;
                                            <Link to={`/Design/${content.contentId}?name=${content.title}`} className="btn btn-primary">
                                                <i className="fa fa-desktop fa-lg" aria-hidden="true"></i></Link>

                                        </td> */}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <div className='text-center'>
                                        <button className="btn btn-outline-primary btn-sm mx-2" onClick={() => handlePageChange(pageNumber - 1)} disabled={pageNumber === 1}>
                                            Previous
                                        </button>
                                        <span>Page {pageNumber} of {totalPages}</span>
                                        <button className="btn btn-outline-primary btn-sm mx-2" onClick={() => handlePageChange(pageNumber + 1)} disabled={pageNumber === totalPages}>
                                            Next
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <ShareModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                screenName={selectedScreenName}
                moduleId={6}
                rowId={selectedrowId}
            />
            <DeleteModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleConfirmDelete}
                message="Are you sure you want to delete this Content?"
                itemName={selectedScreenName}
            />

        </div>
    );
};

export default ContentListComponent